import React from 'react';
import { planetIconPaths, signIconPaths } from '../../Utilities/constants';

// SVGs are black on transparent — invert to white for the dark UI
const iconStyle = {
  verticalAlign: 'middle',
  filter: 'invert(1)',
  opacity: 0.95,
};

/**
 * Inline icon for a planet name.
 * Falls back to a two-letter abbreviation when no SVG exists.
 */
export function PlanetIcon({ name, size = 18, className = '', style = {} }) {
  if (name === 'Node' || name === 'North Node' || name === 'True Node') {
    return (
      <span
        className={className}
        style={{ fontSize: size, lineHeight: 1, color: '#8fd36f', ...style }}
        aria-label={name}
      >
        ☊
      </span>
    );
  }
  if (name === 'South Node') {
    return (
      <span
        className={className}
        style={{ fontSize: size, lineHeight: 1, color: '#8fd36f', ...style }}
        aria-label={name}
      >
        ☋
      </span>
    );
  }
  const src = planetIconPaths[name];
  if (!src) {
    return <span className={className} style={style}>{name ? name.substring(0, 2) : '??'}</span>;
  }
  return (
    <img
      src={src}
      alt={name}
      className={className}
      style={{ ...iconStyle, width: size, height: size, ...style }}
    />
  );
}

/**
 * Inline icon for a zodiac sign name (e.g. "Aries").
 * Falls back to a two-letter abbreviation when no SVG exists.
 */
export function SignIcon({ name, size = 18, className = '', style = {} }) {
  const src = signIconPaths[name];
  if (!src) {
    return <span className={className} style={style}>{name ? name.substring(0, 2) : '??'}</span>;
  }
  return (
    <img
      src={src}
      alt={name}
      className={className}
      style={{ ...iconStyle, width: size, height: size, ...style }}
    />
  );
}
